import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-form_item" }
const _hoisted_2 = { class: "c-form_item_group" }
const _hoisted_3 = ["id", "name", "value", "checked"]
const _hoisted_4 = { class: "c-form_validation_required" }
const _hoisted_5 = { class: "c-form_validation_invalid" }
const _hoisted_6 = ["for"]
const _hoisted_7 = ["id", "name", "value", "required", "checked"]
const _hoisted_8 = { class: "c-form_validation" }
const _hoisted_9 = { class: "c-form_validation_required" }
const _hoisted_10 = { class: "c-form_validation_invalid" }
const _hoisted_11 = ["for"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.choices.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("label", {
            for: "",
            class: _normalizeClass(["c-form_label", { '-required': $props.required }])
          }, _toDisplayString($props.labelText), 3 /* TEXT, CLASS */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.choices, (choice, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("input", {
                ref_for: true,
                ref: "checkboxes$",
                class: "c-form_checkbox",
                type: "checkbox",
                id: choice.id,
                name: $props.name,
                value: choice.value,
                onChange: _cache[0] || (_cache[0] = (...args) => ($options.validate && $options.validate(...args))),
                checked: $props.modelValue.includes(choice.value)
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
              _createElementVNode("div", {
                class: _normalizeClass(["c-form_validation", {' -hidden': index !== $props.choices.length - 1}])
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx._t("You must select at least one option.")), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx._t("This field is invalid.")), 1 /* TEXT */)
              ], 2 /* CLASS */),
              _createElementVNode("label", {
                for: choice.id,
                class: "c-form_checkboxLabel"
              }, _toDisplayString(choice.label), 9 /* TEXT, PROPS */, _hoisted_6)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("input", {
            class: "c-form_checkbox",
            type: "checkbox",
            id: $props.id,
            name: $props.name,
            value: $props.modelValue,
            onChange: _cache[1] || (_cache[1] = $event => (_ctx.$emit('update:modelValue', $event.target.value))),
            required: $props.required,
            checked: $props.modelValue
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx._t("Enter a value for this field.")), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx._t("This field is invalid.")), 1 /* TEXT */)
          ]),
          _createElementVNode("label", {
            for: $props.id,
            class: "c-form_checkboxLabel"
          }, _toDisplayString($props.labelText), 9 /* TEXT, PROPS */, _hoisted_11)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}